import {
  DeleteOutlined,
  EditOutlined,
  FolderAddOutlined,
} from "@ant-design/icons";
import { Table, Space, Tooltip, Popover, Pagination } from "antd";
import React, { useEffect, useState } from "react";
import DeletePlanGroupApi from "../../api/DeletePlanGroupApi";
import ConfirmationModal from "../modal/ConfirmationModal";
import EditPlanGroupModal from "../modal/edit/EditPlanGroupModal";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import { useSelector } from "react-redux";
import { permissionAbility } from "../../helpers/permissionHelpers";
import { LIMIT_PER_PAGE } from "../../helpers/constants";

function PlanGroupsTable(props) {
  const [editModal, setEditModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState("");
  const [deleteGroupId, setDeleteGroupId] = useState("");
  const [editPlanGroup, setEditPlanGroup] = useState();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const positionState = useSelector((state) => state.positionState.value);
  const userLevel = positionState?.userRole?.name;

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  useEffect(() => {
    setPage(props.page);
  }, [props.page]);

  async function deleteGroup() {
    const apiResponse = await DeletePlanGroupApi(deleteGroupId);
    if (apiResponse.statusCode) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", apiResponse.message);
      if (props.data.groups?.length === 1) {
        props.changePage(page - 1);
      } else {
        props.changePage(page);
      }
    } else {
      openNotificationError("bottomRight", "Couldn't delete. Try again later.");
    }
    setDeleteGroupId("");
  }

  const columns = [
    {
      title: "Group name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => <div>{record.name}</div>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      render: (text, record) => (
        <div>{record.description ? record.description : "-"}</div>
      ),
    },
    {
      title: "Default scale",
      dataIndex: "scale",
      key: "scale",
      render: (text, record) => <div>{record.scale?.name}</div>,
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          {permissionAbility(userLevel, "plan-groups", "edit") && (
            <Tooltip title={"Edit"}>
              <div
                onClick={() => {
                  setEditModal(true);
                  setEditPlanGroup(record);
                }}
                className="text-blue-500 hover:text-blue-600 cursor-pointer"
              >
                <EditOutlined />
              </div>
            </Tooltip>
          )}
          {permissionAbility(userLevel, "plan-groups", "delete") &&
            (record.canDelete ? (
              <Tooltip title={"Delete"}>
                <div
                  onClick={() => {
                    setDeleteModal("delete");
                    setDeleteGroupId(record.id);
                  }}
                  className="text-red-500 hover:text-red-600 cursor-pointer"
                >
                  <DeleteOutlined />
                </div>
              </Tooltip>
            ) : record.canArchive ? (
              <Tooltip title={"Archive"}>
                <div
                  onClick={() => {
                    setDeleteModal("archive");
                    setDeleteGroupId(record.id);
                  }}
                  className="text-red-500 hover:text-red-600 cursor-pointer"
                >
                  <FolderAddOutlined />
                </div>
              </Tooltip>
            ) : (
              <Popover
                placement="left"
                content={"This plan group can't be deleted"}
                trigger="hover"
              >
                <div className="text-gray-500">
                  <FolderAddOutlined />
                </div>
              </Popover>
            ))}
        </Space>
      ),
    },
  ];
  return (
    <>
      <Table
        columns={columns}
        dataSource={props.data?.groups}
        pagination={false}
        loading={loading}
      />
      <div className="text-center mt-6">
        <Pagination
          onChange={(num) => props.changePage(num)}
          current={page}
          total={props.data?.totalCount || 0}
          pageSize={LIMIT_PER_PAGE}
        />
      </div>
      <EditPlanGroupModal
        visible={editModal}
        handleCancel={() => {
          setEditModal(false);
          setEditPlanGroup();
        }}
        planGroup={editPlanGroup}
        handleOk={() => props.changePage(page)}
      />
      <ConfirmationModal
        visible={deleteModal}
        handleCancel={() => {
          setDeleteModal("");
          setDeleteGroupId("");
        }}
        handleOk={() => deleteGroup()}
        text={`Are you sure want to ${deleteModal} this plan group?`}
        title={deleteModal?.charAt(0).toUpperCase() + deleteModal?.slice(1)}
      />
    </>
  );
}

export default PlanGroupsTable;
